<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'

const props = defineProps({
	number: {
		type: Number,
		default: 0,
	},
})

const displayNumber = ref(props.number || 0)
let interval = null

const EASING_FACTOR = 0.1
const MIN_CHANGE = 0.1

watch(
	() => props.number,
	() => {
		clearInterval(interval)

		if (props.number === displayNumber.value) {
			return
		}

		interval = window.setInterval(() => {
			if (displayNumber.value !== props.number) {
				const distance = props.number - displayNumber.value
				let change = distance * EASING_FACTOR

				if (Math.abs(change) < MIN_CHANGE) {
					change = MIN_CHANGE * Math.sign(change)
				}

				if (Math.abs(distance) < MIN_CHANGE) {
					displayNumber.value = props.number
				} else {
					displayNumber.value += change
				}
			} else {
				clearInterval(interval)
			}
		}, 16)
	},
	{ immediate: true },
)

onBeforeUnmount(() => {
	if (interval) {
		clearInterval(interval)
	}
})
</script>

<template>{{ Math.round(displayNumber) }}</template>
